(function() {
  /* =====================================================================
     CONFIG
     ===================================================================== */

  var AGILENT_TYPES = [
    { label: 'Diffusion Pumps', url: '/collections/agilent-diffusion-pumps' },
    { label: 'Helium Leak Detectors', url: '/collections/agilent-helium-leak-detectors' },
    { label: 'Ion Pumps', url: '/collections/agilent-ion-pumps' },
    { label: 'Pumping Stations', url: '/collections/agilent-pumping-stations' },
    { label: 'Scroll Pumps', url: '/collections/agilent-scroll-pumps' },
    { label: 'Turbo Pump Controllers', url: '/collections/agilent-turbo-pump-controllers' },
    { label: 'Turbo Pumps', url: '/collections/agilent-turbo-pumps' }
  ];

  // name    = how the brand is shown in the custom Manufacturers list
  // slug    = the handle prefix used in this brand's type collection URLs
  // aliases = how the brand may appear in the Manufacturers filter (case/spacing/punctuation ignored)
  // types[].type = OPTIONAL type slug. Only needed when the URL after "<slug>-" is not the
  //                standard type slug (e.g. inland-vacuum-pump-oils-greases -> vacuum-fluids-greases).
  //                Every brand's collection for the same equipment type must share one type slug.
  var BRANDS = [
    {
      name: 'MD-Kinney',
      prefix: '/collections/md-kinney',
      slug: 'md-kinney',
      aliases: ['md-kinney', 'md kinney', 'kinney'],
      title: 'Equipment Type',
      types: [
        { label: 'Blowers & Boosters', url: '/collections/md-kinney-blowers-and-boosters' },
        { label: 'Dry Pumps', url: '/collections/md-kinney-dry-pumps' },
        { label: 'Liquid Ring', url: '/collections/md-kinney-liquid-ring' },
        { label: 'Piston Pumps', url: '/collections/md-kinney-piston-pumps' },
        { label: 'Vane Pumps', url: '/collections/md-kinney-vane-pumps' },
        { label: 'Vacuum Fluids & Greases', url: '/collections/md-kinney-vacuum-fluids-greases' }
      ]
    },
    {
      name: 'Leybold',
      prefix: '/collections/leybold',
      slug: 'leybold',
      aliases: ['leybold', 'leybold vacuum', 'oerlikon leybold'],
      title: 'Equipment Type',
      types: [
        { label: 'Blowers & Boosters', url: '/collections/leybold-blowers-and-boosters' },
        { label: 'Diaphragm Pumps', url: '/collections/leybold-diaphragm-pumps' },
        { label: 'Diffusion Pumps', url: '/collections/leybold-diffusion-pumps' },
        { label: 'Dry Pumps', url: '/collections/leybold-dry-pumps' },
        { label: 'Helium Leak Detectors', url: '/collections/leybold-helium-leak-detectors' },
        { label: 'Oil Filtration Systems', url: '/collections/leybold-oil-filtration-systems' },
        { label: 'Oil-Sealed Screw Pumps', url: '/collections/leybold-oil-sealed-screw-pumps' },
        { label: 'Piston Pumps', url: '/collections/leybold-piston-pumps' },
        { label: 'Pumping Stations', url: '/collections/leybold-pumping-stations' },
        { label: 'Scroll Pumps', url: '/collections/leybold-scroll-pumps' },
        { label: 'Turbo Pump Controllers', url: '/collections/leybold-turbo-pump-controllers' },
        { label: 'Turbo Pumps', url: '/collections/leybold-turbo-pumps' },
        { label: 'Vacuum Fluids & Greases', url: '/collections/leybold-vacuum-fluids-greases' },
        { label: 'Vane Pumps', url: '/collections/leybold-vane-pumps' }
      ]
    },
    {
      name: 'Vacuubrand',
      prefix: '/collections/vacuubrand',
      slug: 'vacuubrand',
      aliases: ['vacuubrand'],
      title: 'Equipment Type',
      types: [
        { label: 'Diaphragm Pumps', url: '/collections/vacuubrand-diaphragm-pumps' },
        { label: 'Dry Pumps', url: '/collections/vacuubrand-dry-pumps' },
        { label: 'Turbo Pump Controllers', url: '/collections/vacuubrand-turbo-pump-controllers' },
        { label: 'Vane Pumps', url: '/collections/vacuubrand-vane-pumps' }
      ]
    },
    {
      name: 'Pfeiffer',
      prefix: '/collections/pfeiffer',
      slug: 'pfeiffer',
      aliases: ['pfeiffer', 'pfeiffer vacuum'],
      title: 'Equipment Type',
      types: [
        { label: 'Blowers & Boosters', url: '/collections/pfeiffer-blowers-and-boosters' },
        { label: 'Diaphragm Pumps', url: '/collections/pfeiffer-diaphragm-pumps' },
        { label: 'Dry Pumps', url: '/collections/pfeiffer-dry-pumps' },
        { label: 'Helium Leak Detectors', url: '/collections/pfeiffer-helium-leak-detectors' },
        { label: 'Piston Pumps', url: '/collections/pfeiffer-piston-pumps' },
        { label: 'Pumping Stations', url: '/collections/pfeiffer-pumping-stations' },
        { label: 'Scroll Pumps', url: '/collections/pfeiffer-scroll-pumps' },
        { label: 'Turbo Pumps', url: '/collections/pfeiffer-turbo-pumps' },
        { label: 'Turbo Pump Controllers', url: '/collections/pfeiffer-turbo-pump-controllers' },
        { label: 'Vane Pumps', url: '/collections/pfeiffer-vane-pumps' }
      ]
    },
    {
      name: 'Edwards',
      prefix: '/collections/edwards',
      slug: 'edwards',
      aliases: ['edwards'],
      title: 'Equipment Type',
      types: [
        { label: 'Accessories', url: '/collections/edwards-accessories' },
        { label: 'Blowers & Boosters', url: '/collections/edwards-blowers-and-boosters' },
        { label: 'Diaphragm Pumps', url: '/collections/edwards-diaphragm-pumps' },
        { label: 'Diffusion Pumps', url: '/collections/edwards-diffusion-pumps' },
        { label: 'Dry Pumps', url: '/collections/edwards-dry-pumps' },
        { label: 'Helium Leak Detectors', url: '/collections/edwards-helium-leak-detectors' },
        { label: 'Oil Filtration Systems', url: '/collections/edwards-oil-filtration-systems' },
        { label: 'Piston Pumps', url: '/collections/edwards-piston-pumps' },
        { label: 'Pumping Stations', url: '/collections/edwards-pumping-stations' },
        { label: 'Scroll Pumps', url: '/collections/edwards-scroll-pumps' },
        { label: 'Turbo Pumps', url: '/collections/edwards-turbo-pumps' },
        { label: 'Turbo Pump Controllers', url: '/collections/edwards-turbo-pump-controllers' },
        { label: 'Vacuum Gauges', url: '/collections/edwards-vacuum-gauges' },
        { label: 'Vane Pumps', url: '/collections/edwards-vane-pumps' }
      ]
    },
    {
      name: 'Atlas Copco',
      prefix: '/collections/atlas-copco',
      slug: 'atlas-copco',
      aliases: ['atlas-copco', 'atlas copco'],
      title: 'Equipment Type',
      types: [
        { label: 'Blowers & Boosters', url: '/collections/atlas-copco-blowers-and-boosters' },
        { label: 'Dry Pumps', url: '/collections/atlas-copco-dry-pumps' },
        { label: 'Oil-Sealed Screw Pumps', url: '/collections/atlas-copco-oil-sealed-screw-pumps' },
        { label: 'Piston Pumps', url: '/collections/atlas-copco-piston-pumps' },
        { label: 'Vane Pumps', url: '/collections/atlas-copco-vane-pumps' }
      ]
    },
    {
      name: 'Inland',
      prefix: '/collections/inland',
      slug: 'inland',
      aliases: ['inland', 'inland vacuum'],
      title: 'Equipment Type',
      types: [
        // Grouped with every other brand's Vacuum Fluids & Greases collection
        { label: 'Vacuum Pump Oils & Greases', url: '/collections/inland-vacuum-pump-oils-greases', type: 'vacuum-fluids-greases' }
      ]
    },
    {
      name: 'Agilent (Varian)',
      prefix: '/collections/varian',
      slug: 'agilent',
      aliases: ['varian'],
      title: 'Equipment Type',
      types: AGILENT_TYPES
    },
    {
      name: 'Agilent (Varian)',
      prefix: '/collections/agilent',
      slug: 'agilent',
      aliases: ['agilent', 'agilent varian', 'agilent-varian'],
      title: 'Equipment Type',
      types: AGILENT_TYPES
    },
    {
      name: 'Anest Iwata',
      prefix: '/collections/anest-iwata',
      slug: 'anest-iwata',
      aliases: ['anest-iwata', 'anest iwata', 'anest'],
      title: 'Equipment Type',
      types: [
        { label: 'Scroll Pumps', url: '/collections/anest-iwata-scroll-pumps' }
      ]
    },
    {
      name: 'Welch',
      prefix: '/collections/welch',
      slug: 'welch',
      aliases: ['welch', 'welch vacuum', 'gardner denver welch', 'welch ilmvac'],
      title: 'Equipment Type',
      types: [
        { label: 'Diaphragm Pumps', url: '/collections/welch-diaphragm-pumps' },
        { label: 'Dry Pumps', url: '/collections/welch-dry-pumps' },
        { label: 'Scroll Pumps', url: '/collections/welch-scroll-pumps' },
        { label: 'Vane Pumps', url: '/collections/welch-vane-pumps' }
      ]
    },
    {
      name: 'CTI',
      prefix: '/collections/cti',
      slug: 'cti',
      aliases: ['cti', 'cti-cryogenics', 'cti cryogenics', 'cti cryo'],
      title: 'Equipment Type',
      types: [
        { label: 'Cryo Pumps & Compressors', url: '/collections/cti-cryo-pumps-and-compressors' }
      ]
    },
    {
      name: 'Kashiyama',
      prefix: '/collections/kashiyama',
      slug: 'kashiyama',
      aliases: ['kashiyama', 'kashiyama industries'],
      title: 'Equipment Type',
      types: [
        { label: 'Dry Pumps', url: '/collections/kashiyama-dry-pumps' }
      ]
    },
    {
      name: 'Shimadzu',
      prefix: '/collections/shimadzu',
      slug: 'shimadzu',
      aliases: ['shimadzu', 'shimadzu corporation'],
      title: 'Equipment Type',
      types: [
        { label: 'Turbo Pump Controllers', url: '/collections/shimadzu-turbo-pump-controllers' },
        { label: 'Turbo Pumps', url: '/collections/shimadzu-turbo-pumps' }
      ]
    },
    {
      name: 'Ulvac',
      prefix: '/collections/ulvac',
      slug: 'ulvac',
      aliases: ['ulvac', 'ulvac inc', 'ulvac technologies', 'ulvac kiko'],
      title: 'Equipment Type',
      types: [
        { label: 'Diffusion Pumps', url: '/collections/ulvac-diffusion-pumps' },
        { label: 'Scroll Pumps', url: '/collections/ulvac-scroll-pumps' }
      ]
    }
  ];

  // The all-brands collection for each type slug.
  // Used two ways:
  //  1. Generic type pages whose handle differs from the type slug still get brand links
  //     (e.g. /collections/diaphragm-pump -> type "diaphragm-pumps").
  //  2. An "All Brands" link at the top of the Manufacturers list on brand+type pages.
  // Leave a type out if it has no all-brands collection.
  var GENERIC_TYPE_COLLECTIONS = {
    'blowers-and-boosters': '/collections/blowers-and-boosters',
    'cryo-pumps-and-compressors': '/collections/cryo-pumps-and-compressors',
    'diaphragm-pumps': '/collections/diaphragm-pump',
    'diffusion-pumps': '/collections/diffusion-pumps',
    'dry-pumps': '/collections/dry-pumps',
    'helium-leak-detectors': '/collections/helium-leak-detectors',
    'oil-filtration-systems': '/collections/oil-filtration-system',
    'piston-pumps': '/collections/piston-pumps',
    'pumping-stations': '/collections/pumping-station',
    'scroll-pumps': '/collections/scroll-pumps',
    'turbo-pumps': '/collections/turbo-pumps',
    'vacuum-fluids-greases': '/collections/vacuum-fluids-and-greases',
    'vane-pumps': '/collections/vane-pumps'
  };

  // Show "All Brands" as the first item of the Manufacturers list on brand+type pages
  var SHOW_ALL_BRANDS_LINK = true;

  // Titles the Manufacturers filter block may use in Boost
  var MANUFACTURER_TITLES = ['manufacturers', 'manufacturer', 'brand', 'brands', 'vendor'];

  var TYPE_NAV_ID = 'mdk-type-nav';
  var MFR_NAV_ID = 'mdk-mfr-nav';

  /* =====================================================================
     HELPERS
     ===================================================================== */

  function normalize(str) {
    return (str || '')
      .toLowerCase()
      .replace(/\(\s*\d+\s*\)/g, '')   // strip "(12)" counts if present
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function typeSlugOf(brand, t) {
    if (t.type) return t.type;
    var urlPrefix = '/collections/' + brand.slug + '-';
    return t.url.indexOf(urlPrefix) === 0 ? t.url.slice(urlPrefix.length) : null;
  }

  function getCollectionHandle(path) {
    var m = path.match(/^\/collections\/([^\/?#]+)/);
    return m ? m[1].toLowerCase() : null;
  }

  function getBrand(path) {
    for (var i = 0; i < BRANDS.length; i++) {
      var p = BRANDS[i].prefix;
      // Match "/collections/leybold" and "/collections/leybold-..." only
      if (path === p || path.indexOf(p + '-') === 0 || path.indexOf(p + '/') === 0) return BRANDS[i];
    }
    return null;
  }

  // typeSlug -> { normalizedAlias: brandTypeUrl }   (for native filter linking)
  // typeSlug -> [ { name, url } ]                   (for the custom Manufacturers list)
  var TYPE_INDEX = {};
  var TYPE_BRANDS = {};
  (function() {
    BRANDS.forEach(function(b) {
      b.types.forEach(function(t) {
        var typeSlug = typeSlugOf(b, t);
        if (!typeSlug) return;

        if (!TYPE_INDEX[typeSlug]) TYPE_INDEX[typeSlug] = {};
        b.aliases.forEach(function(a) {
          TYPE_INDEX[typeSlug][normalize(a)] = t.url;
        });

        if (!TYPE_BRANDS[typeSlug]) TYPE_BRANDS[typeSlug] = [];
        var exists = TYPE_BRANDS[typeSlug].some(function(x) { return x.url === t.url; });
        if (!exists) TYPE_BRANDS[typeSlug].push({ name: b.name, url: t.url });
      });
    });
    Object.keys(TYPE_BRANDS).forEach(function(k) {
      TYPE_BRANDS[k].sort(function(a, b) { return a.name.localeCompare(b.name); });
    });
  })();

  // generic collection handle -> type slug
  var GENERIC_HANDLE_TO_TYPE = {};
  Object.keys(GENERIC_TYPE_COLLECTIONS).forEach(function(typeSlug) {
    var handle = getCollectionHandle(GENERIC_TYPE_COLLECTIONS[typeSlug]);
    if (handle) GENERIC_HANDLE_TO_TYPE[handle] = typeSlug;
  });

  // On a brand+type page, returns { brand, type, typeSlug }, else null
  function getBrandTypePage(path) {
    var brand = getBrand(path);
    if (!brand) return null;
    var handle = getCollectionHandle(path);
    if (!handle) return null;
    for (var i = 0; i < brand.types.length; i++) {
      var t = brand.types[i];
      if (t.url === '/collections/' + handle) {
        var typeSlug = typeSlugOf(brand, t);
        return typeSlug ? { brand: brand, type: t, typeSlug: typeSlug } : null;
      }
    }
    return null;
  }

  // Returns the brand map for the current generic type collection, or null
  function getTypeBrandMap(path) {
    if (getBrand(path)) return null; // brand pages are handled by renderNav / renderManufacturers
    var handle = getCollectionHandle(path);
    if (!handle) return null;
    var typeSlug = GENERIC_HANDLE_TO_TYPE[handle] || handle;
    return TYPE_INDEX[typeSlug] || null;
  }

  function getOptionTitle(opt) {
    var titleEl = opt.querySelector('.boost-pfs-filter-option-title-text');
    return titleEl ? (titleEl.textContent || '').trim() : '';
  }

  function isOurs(opt) {
    return opt.id === TYPE_NAV_ID || opt.id === MFR_NAV_ID;
  }

  // Builds a sidebar block styled like a Boost filter option
  function buildOptionBlock(id, titleText, items, currentPath) {
    var block = document.createElement('div');
    block.id = id;
    block.className = 'boost-pfs-filter-option boost-pfs-filter-option-list';

    var title = '<div class="boost-pfs-filter-option-title">' +
      '<span class="boost-pfs-filter-option-title-text" style="font-weight:700;text-transform:uppercase;">' +
      escapeHtml(titleText) + '</span></div>';

    var listItems = items.map(function(t) {
      var isActive = currentPath === t.url;
      var boxStyle = 'display:inline-flex;align-items:center;justify-content:center;' +
        'width:16px;height:16px;margin-right:10px;flex:0 0 auto;box-sizing:border-box;' +
        'background:#fff;border:2px solid ' + (isActive ? '#000' : '#999') + ';';
      var check = isActive
        ? '<svg width="10" height="10" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M1 6L4.5 9.5L11 2.5" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '';
      return '<li class="boost-pfs-filter-option-item boost-pfs-filter-option-label">' +
        '<a href="' + escapeHtml(t.url) + '" class="boost-pfs-filter-button" style="text-decoration:none;display:flex;align-items:center;">' +
        '<span class="boost-pfs-check-box" style="' + boxStyle + '">' + check + '</span>' +
        '<span class="boost-pfs-filter-option-value" style="color:#333;font-weight:' + (isActive ? '700' : '400') + ';">' +
        escapeHtml(t.label) + '</span></a></li>';
    }).join('');

    block.innerHTML = title +
      '<div class="boost-pfs-filter-option-content"><div class="boost-pfs-filter-option-content-inner">' +
      '<ul class="boost-pfs-filter-option-item-list boost-pfs-filter-option-item-list-multiple-list">' +
      listItems + '</ul></div></div>';

    return block;
  }

  // Our links must navigate, not trigger Boost's filter handler
  function stopBoost(e) {
    e.stopPropagation();
  }

  /* =====================================================================
     BRAND PAGES: Equipment Type nav
     ===================================================================== */

  function hideNativeEquipmentType(brandTitle) {
    var options = document.querySelectorAll('.boost-pfs-filter-option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (isOurs(opt)) continue;
      if (getOptionTitle(opt).toLowerCase() === brandTitle.toLowerCase()) {
        opt.style.display = 'none';
      }
    }
  }

  function renderNav() {
    var path = window.location.pathname;
    var brand = getBrand(path);
    if (!brand) return;

    hideNativeEquipmentType(brand.title);

    if (document.getElementById(TYPE_NAV_ID)) return;

    var optionsWrapper = document.querySelector('.boost-pfs-filter-options-wrapper');
    if (!optionsWrapper) return;

    var nav = buildOptionBlock(TYPE_NAV_ID, brand.title, brand.types, path);
    nav.addEventListener('click', stopBoost);
    optionsWrapper.insertBefore(nav, optionsWrapper.firstChild);
  }

  /* =====================================================================
     BRAND+TYPE PAGES: Manufacturers list with every completed brand
     e.g. on /collections/leybold-turbo-pumps you still see MD-Kinney, Pfeiffer, Edwards...
     ===================================================================== */

  function renderManufacturers() {
    var path = window.location.pathname;
    var page = getBrandTypePage(path);
    if (!page) return;

    var brands = TYPE_BRANDS[page.typeSlug] || [];
    var genericUrl = GENERIC_TYPE_COLLECTIONS[page.typeSlug];

    // Hide Boost's native Manufacturers block (it only lists the current brand here)
    var nativeTitle = '';
    var options = document.querySelectorAll('.boost-pfs-filter-option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (isOurs(opt)) continue;
      var t = getOptionTitle(opt);
      if (MANUFACTURER_TITLES.indexOf(t.toLowerCase()) !== -1) {
        if (!nativeTitle) nativeTitle = t;
        opt.style.display = 'none';
      }
    }

    if (document.getElementById(MFR_NAV_ID)) return;

    // Nothing to switch to: leave a single-brand list out
    if (brands.length < 2 && !(SHOW_ALL_BRANDS_LINK && genericUrl)) return;

    var optionsWrapper = document.querySelector('.boost-pfs-filter-options-wrapper');
    if (!optionsWrapper) return;

    var items = [];
    if (SHOW_ALL_BRANDS_LINK && genericUrl) items.push({ label: 'All Brands', url: genericUrl });
    brands.forEach(function(b) { items.push({ label: b.name, url: b.url }); });

    var block = buildOptionBlock(MFR_NAV_ID, nativeTitle || 'Manufacturers', items, path);
    block.addEventListener('click', stopBoost);

    var typeNav = document.getElementById(TYPE_NAV_ID);
    if (typeNav && typeNav.parentNode === optionsWrapper) {
      optionsWrapper.insertBefore(block, typeNav.nextSibling);
    } else {
      optionsWrapper.insertBefore(block, optionsWrapper.firstChild);
    }
  }

  /* =====================================================================
     GENERIC TYPE PAGES: native Manufacturers -> brand+type collection
     ===================================================================== */

  function linkManufacturers() {
    var brandMap = getTypeBrandMap(window.location.pathname);
    if (!brandMap) return;

    var options = document.querySelectorAll('.boost-pfs-filter-option');
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (isOurs(opt)) continue;
      if (MANUFACTURER_TITLES.indexOf(getOptionTitle(opt).toLowerCase()) === -1) continue;

      var items = opt.querySelectorAll('.boost-pfs-filter-option-item');
      for (var j = 0; j < items.length; j++) {
        var item = items[j];
        if (item.getAttribute('data-brand-url')) continue; // already processed

        var valueEl = item.querySelector('.boost-pfs-filter-option-value');
        var label = normalize(valueEl ? valueEl.textContent : item.textContent);
        var url = brandMap[label];
        if (!url) continue; // brand page not complete yet: keep native filter

        item.setAttribute('data-brand-url', url);
        item.style.cursor = 'pointer';

        // Give it a real href so it's crawlable and supports open-in-new-tab
        var btn = item.querySelector('a, button');
        if (btn && btn.tagName === 'A') btn.setAttribute('href', url);
      }
    }
  }

  // Capture phase so we run before Boost's own filter click handler
  document.addEventListener('click', function(e) {
    var item = e.target.closest && e.target.closest('.boost-pfs-filter-option-item[data-brand-url]');
    if (!item) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) {
      // Let modified clicks open the real href in a new tab
      e.stopImmediatePropagation();
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = item.getAttribute('data-brand-url');
  }, true);

  /* =====================================================================
     RUN
     ===================================================================== */

  function run() {
    renderNav();
    renderManufacturers();
    linkManufacturers();
  }

  run();

  new MutationObserver(function() {
    run();
  }).observe(document.body, { subtree: true, childList: true });
})();